import { Box } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import { forwardRef } from 'react';
import SkeletonContainer from '../SkeletonContainer';

export const SkeletonListItem = forwardRef<HTMLDivElement>((_, ref) => (
  <SkeletonContainer ref={ref}>
    <Box css={{ margin: 'default' }}>
      <Bone css={{ width: '65%' }} />
      <Bone css={{ width: '80%', marginTop: 'default' }} />
    </Box>
  </SkeletonContainer>
));
